<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('walls.create.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('walls.create.title') }}</h3>
      </d-col>
    </d-row>

    <puzzle-walls-page/>
  </d-container>
</template>

<script>
import PuzzleWallsPage from '../components/PuzzleWallsPage.vue';

export default {
  name: 'puzzle-walls-create',
  components: {
    PuzzleWallsPage,
  },
};
</script>
